import * as React from 'react'
import {
  CATALOG_SERIE_NAMES,
  buildCompareProduct,
  canShowCatalogCompare,
  formatCatalogPrice,
  getProductDetailUrl,
  getProductImageSrc,
  shouldOpenInNewWindow,
} from '../../screens/ProductCatalogueV2/productLogic'
import {
  Card,
  ImageArea,
  SerieBadge,
  CompareButtonDesktop
} from './styledComponents'
import { CompareProduct, ImageType, Product } from '../../types/common'
import JackrooLogo from '../../assets/Jackroologo.svg'
import { getFilterDisplayLabel } from '../../screens/ProductCatalogueV2/constants'

interface Props {
  history: any
  product: Product
  images?: ImageType
  currentCurrency: string
  compareProducts?: Record<number, boolean>
  isSelected?: boolean
  genderFilter?: string
  forceDesktop?: boolean
  onClick?: (product: Product, checked: boolean) => void
  addToCompareAction?: (product: CompareProduct) => void
  deleteCompareProductAction?: (id: number) => void
}

export class CatalogProductCard extends React.Component<Props> {
  handleNavigate = (event: React.MouseEvent<HTMLElement>) => {
    const { product, history, genderFilter, onClick, isSelected } = this.props
    const { id, yotpoId, genders } = product
    if (onClick) {
      onClick(product, !isSelected)
      return
    }
    const isMobile =
      typeof window !== 'undefined' &&
      window.matchMedia('(min-width: 320px) and (max-width: 480px)').matches

    const productUrl = getProductDetailUrl({
      id,
      yotpoId,
      genders,
      gender: genderFilter
    })
    if (shouldOpenInNewWindow(event) || isMobile) {
      window.open(productUrl)
      return
    }
    history.push(productUrl)
  }

  handleCompare = () => {
    const { product, images, addToCompareAction, deleteCompareProductAction, compareProducts } = this.props
    const isBeingCompared = compareProducts ? compareProducts[product.id] : false

    if (!addToCompareAction || !deleteCompareProductAction) {
      return
    }

    if (isBeingCompared) {
      deleteCompareProductAction(product.id)
      return
    }

    const compareObj = buildCompareProduct({ product, images, fallbackImage: JackrooLogo })
    addToCompareAction(compareObj)
  }
  stopEventPropagation = (event: React.MouseEvent) => {
    event.stopPropagation()
  }
  render() {
    const {
      product,
      images,
      isSelected,
      forceDesktop = false,
      currentCurrency,
      compareProducts,
      addToCompareAction
    } = this.props
    const {
      id,
      type: productName,
      description,
      priceRange,
      customizable,
      comingSoon,
      serie
    } = product

    const isMobile = !forceDesktop &&
      typeof window !== 'undefined' &&
      window.matchMedia('(max-width: 480px)').matches

    const isBeingCompared = compareProducts ? compareProducts[id] : false
    const showCompare = canShowCatalogCompare({
      productId: id,
      comingSoon,
      customizable,
      addToCompareAction,
      isMobile
    })

    const priceText = formatCatalogPrice(priceRange, currentCurrency)
    const serieLabel = serie !== null && serie !== undefined ? 
      getFilterDisplayLabel('series', CATALOG_SERIE_NAMES[serie]) : ''
    const imageSrc = getProductImageSrc(images, JackrooLogo)

    return (
      <Card 
        data-appearance="catalog" 
        data-force-desktop={forceDesktop} 
        onClick={this.handleNavigate} 
        data-selected={isSelected}
      >
        <ImageArea className={images && images.thumbnailAlt ? 'has-alt' : ''}>
          <img className="main-image" src={imageSrc} alt={productName} />
          {images && images.thumbnailAlt &&
            <img className="alt-image" src={images.thumbnailAlt} alt={`${productName} alt`} />
          }
        </ImageArea>
        <div id="CatalogCardBody">
          {serieLabel && (
            <div id="CatalogMobileSeriesBadge">
              <SerieBadge data-serie={serie}>{serieLabel}</SerieBadge>
            </div>
          )}

          <div id="CatalogDesktopTopRow" onClick={this.stopEventPropagation}>
            <h3 className="catalog-product-name">{productName}</h3>
            {showCompare && !isMobile && (
              <CompareButtonDesktop
                data-button-appearance="compare"
                checked={isBeingCompared}
                onClick={this.handleCompare}
              >
                Compare
              </CompareButtonDesktop>
            )}
          </div>
          <h3 id="CatalogMobileProductName" className="catalog-product-name">
            {productName}
          </h3>
          <p id="CatalogProductSubtitle">{description}</p>
          <div id="CatalogDesktopFooterRow">
            {serieLabel ? <SerieBadge data-serie={serie}>{serieLabel}</SerieBadge> : <span />}
            {priceText && (
              <div id="CatalogPriceRow">
                <span className="catalog-price-value">{priceText}</span>
                <span className="catalog-price-quantity">(13-24pcs)</span>
              </div>
            )}
          </div>
          <div id="CatalogMobilePriceRow">
            {priceText && <>
              <span className="catalog-price-value">{priceText}</span>
              <span className="catalog-price-quantity">(13-24pcs)</span>
            </>}
          </div>
          {showCompare && isMobile && (
            <div style={{ flex: 1, display: 'flex', alignItems: 'flex-end' }} onClick={this.stopEventPropagation}>
              <CompareButtonDesktop
                data-button-appearance="compare"
                checked={isBeingCompared}
                onClick={this.handleCompare}
              >
                Compare
              </CompareButtonDesktop>
            </div>
          )}
        </div>
      </Card>
    )
  }
}

export default CatalogProductCard



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/CatalogProductCardV2/index.tsx